import React, {useState} from 'react';

import {resetPassword} from '../../api';
import {Button, Input, Notification, Title} from '../../components';
import {Logo} from '../../assets';

const ResetPassword = ({history, match}) => {
  const resetToken = match.params.resetToken;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [notif, setNotif] = useState('');

  const resetPasswordHandler = async (e) => {
    e.preventDefault();
    setNotif('');

    if (password !== confirmPassword) {
      setTimeout(() => {
        setNotif('');
      }, 2000);
      return setNotif({type: 'error', text: 'Les mots de passe ne correspondent pas.'});
    }

    const {data, error} = await resetPassword(resetToken, email, password);
    if (error) return setNotif({type: 'error', text: error});
    setNotif({type: 'success', text: data});
    setTimeout(() => {
      history.replace('/connexion');
    }, 1500);
  };

  return (
    <div className="log-container">
      <div className="content-login">
        <div className="login-container-logo">
          <img src={Logo} alt="Sublissime" />
        </div>
        <Title
          text={
            match.path === '/finalisation-du-compte/:resetToken'
              ? 'Validation de votre compte Sublisime'
              : 'Choisissez votre nouveau mot de passe'
          }
        />
        <form onSubmit={resetPasswordHandler} className="login-form">
          <Input
            label="Votre addresse e-mail"
            type="email"
            name="email"
            autoComplete="email"
            value={email}
            handleChange={(e) => setEmail(e.target.value)}
            light
            required
          />
          <Input
            label="Votre mot de passe"
            type="password"
            name="password"
            minLength="6"
            value={password}
            handleChange={(e) => setPassword(e.target.value)}
            light
            required
          />
          <Input
            label="Confirmez votre mot de passe"
            type="password"
            name="password"
            minLength="6"
            value={confirmPassword}
            handleChange={(e) => setConfirmPassword(e.target.value)}
            light
            required
          />
          <Button type="submit" label="Valider" login />
        </form>
        {notif && <Notification type={notif.type} text={notif.text} />}
      </div>
    </div>
  );
};

export default ResetPassword;
